import { render, staticRenderFns } from "./IconSvgLink.vue?vue&type=template&id=7427e3e9&scoped=true&"
import script from "./IconSvgLink.vue?vue&type=script&lang=js&"
export * from "./IconSvgLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7427e3e9",
  null
  
)

export default component.exports